angular.module('clients')
    .component('clientShow', {
        bindings: {
            item: '<',
            filters: '<'
        },
        templateUrl: 'app/clients/show.html',
        controller: function ($scope, $state, Deal, Document, ClientConst, ClientService, SmsService, NoteService, TaskService, DealService, Principal) {
            this.ClientService = ClientService
            this.SmsService = SmsService
            this.canReadLeadConsents = Principal.hasAnyAuthority(['ROLE_LEADS'])
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])

            this.$onInit = () => {
                this.loadDeals()
            }
            this.addNote = () => NoteService.addModal({clients: [this.item]}).then(() => $state.reload())
            this.addTask = () => TaskService.addModal({clients: [this.item]}).then(() => $state.reload())
            this.addDeal = () => DealService.addModal({client: this.item}).then(() => $state.reload())
            this.loadDeals = () => {
                let canReadDeals = Principal.hasAnyAuthority(['ROLE_DEALS']);
                if (canReadDeals) {
                    Deal.find({client: this.item.id}).$promise.then(deals => this.deals = deals)
                }
            }

            this.onDocumentsLoaded = page => this.documentsCount = page.fullListSize || 0
            this.onConsentsLoaded = items => this.consentsCount = (items || []).length
            this.sortedContacts = contacts => {
                const order = {PHONE: 1, EMAIL: 2, WEBSITE: 3, OTHER: 4}
                return (contacts || []).slice().sort((a, b) => {
                    const typeCompare = (order[a.type] || 9) - (order[b.type] || 9)
                    if (typeCompare !== 0) {
                        return typeCompare
                    }
                    return (a.id || 0) - (b.id || 0)
                })
            }
            this.normalizeWebsiteUrl = value => {
                if (!value) {
                    return null
                }
                return /^https?:\/\//i.test(value) ? value : 'http://' + value
            }

            $scope.$on(ClientConst.eventUpdate, () => $state.reload())
        }
    })
